"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mapEventsToUrls = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _networkRequest = _interopRequireWildcard(require("../networkRequest"));

var _constants = require("../constants");

var _logger = _interopRequireDefault(require("../utils/logger"));

var _structureData = require("./structureData");

var _cheggIdManager = require("../utils/cheggIdManager");

var _misc = require("../utils/misc");

var mapEventsToUrls = function mapEventsToUrls(events) {
  return events.reduce(function (urlEventMap, event) {
    var endpoint = event.options.endpoint || 'default';
    var eventsForUrl = urlEventMap[endpoint] || [];
    eventsForUrl.push(event.payload);
    urlEventMap[endpoint] = eventsForUrl;
    return urlEventMap;
  }, {});
};

exports.mapEventsToUrls = mapEventsToUrls;

var Batcher = function Batcher(client) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, Batcher);
  (0, _defineProperty2["default"])(this, "cheggIdManager", new _cheggIdManager.CheggIdManager());
  (0, _defineProperty2["default"])(this, "_eventCache", void 0);
  (0, _defineProperty2["default"])(this, "_runningTimeout", void 0);
  (0, _defineProperty2["default"])(this, "_countdownPromise", void 0);
  (0, _defineProperty2["default"])(this, "client", void 0);
  (0, _defineProperty2["default"])(this, "_readAndEmptyCache", function () {
    return _this._eventCache.splice(0, _this._eventCache.length);
  });
  (0, _defineProperty2["default"])(this, "queueEvent", /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(payload, options) {
      var force, sendPromise;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Cache event and hold for bulk send:
              force = options.force;
              delete options.force;

              _this._eventCache.push({
                payload: payload,
                options: options
              });

              _context.prev = 3;

              if (force) {
                sendPromise = _this.flushCachedEvents();
              } else {
                sendPromise = _this.startCountdown();
              }

              return _context.abrupt("return", sendPromise);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);

              _logger["default"].error(_context.t0);

              return _context.abrupt("return", _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 8]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  (0, _defineProperty2["default"])(this, "startCountdown", function () {
    if ((0, _misc.noWindow)()) {
      return;
    } // Ensure only one countdown exists at a time. This single promise will be returned to
    // all callers of client.event, and will resolve when the endpoint has responded to the
    // bulk insert request.


    _this._countdownPromise = _this._countdownPromise || new Promise(function (resolve, reject) {
      _this._runningTimeout = window.setTimeout(function () {
        _this.sendCachedEvents().then(resolve)["catch"](reject);
      }, _this.client.batchInterval);
    });
    _this._countdownPromise;
  });
  (0, _defineProperty2["default"])(this, "resetCountdown", function () {
    if (_this._runningTimeout) {
      clearTimeout(_this._runningTimeout);
    }

    _this._runningTimeout = undefined;
    _this._countdownPromise = undefined;
  });
  (0, _defineProperty2["default"])(this, "flushCachedEvents", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var cacheContents, sendPromises, urlEventMap;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // Clear cache, moving contents to array we'll be sending to endpoint:
            cacheContents = _this._readAndEmptyCache();
            sendPromises = [];

            if (cacheContents.length) {
              urlEventMap = mapEventsToUrls(cacheContents);
              sendPromises = Object.keys(urlEventMap).map( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
                  var events, endpoint;
                  return _regenerator["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          events = urlEventMap[url];
                          _context2.next = 3;
                          return (0, _structureData.enrichEventsWithAdobeData)(events);

                        case 3:
                          events = _context2.sent;
                          _context2.next = 6;
                          return _this.cheggIdManager.enrichEventsWithCheggIds(events);

                        case 6:
                          events = _context2.sent;
                          endpoint = url === 'default' ? _this.client.endpoint : url;
                          _context2.next = 10;
                          return (0, _networkRequest.sendImmediateRequest)({
                            url: endpoint,
                            data: events
                          });

                        case 10:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            }

            _context3.next = 5;
            return Promise.all(sendPromises);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));
  (0, _defineProperty2["default"])(this, "sendCachedEvents", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var cacheContents, sendPromises, urlEventMap;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            // If `sendCachedEvents` was called directly (instead of through `startCountdown`), the countdown
            // should be shut off to avoid excess calls
            _this.resetCountdown(); // Clear cache, moving contents to array we'll be sending to endpoint:


            cacheContents = _this._readAndEmptyCache(); // In the case of a prior force send, there may be nothing left to relay in the cache.
            // In this case, all awaiting promises will have been resolved, and we can avoid another
            // call to the endpoint.

            sendPromises = [];

            if (cacheContents.length) {
              urlEventMap = mapEventsToUrls(cacheContents);
              sendPromises = Object.keys(urlEventMap).map( /*#__PURE__*/function () {
                var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(url) {
                  var events, endpoint;
                  return _regenerator["default"].wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          events = urlEventMap[url];
                          _context4.next = 3;
                          return (0, _structureData.enrichEventsWithAdobeData)(events);

                        case 3:
                          events = _context4.sent;
                          _context4.next = 6;
                          return _this.cheggIdManager.enrichEventsWithCheggIds(events);

                        case 6:
                          events = _context4.sent;
                          endpoint = url === 'default' ? _this.client.endpoint : url; // Send to analytics endpoint:

                          return _context4.abrupt("return", (0, _networkRequest["default"])({
                            url: endpoint,
                            data: events,
                            retries: _constants.DATA_REQUEST_RETRIES
                          }));

                        case 9:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());
            }

            return _context5.abrupt("return", Promise.all(sendPromises));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })));
  this._eventCache = [];
  this.client = client;
};

var _default = Batcher;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/rio-sdk-web/dist/cjs/client/batcher.js
// module id = 3470
// module chunks = 11